import { createSlice } from '@reduxjs/toolkit';

import type { NPage } from '@app/components/Page/types/Page.main';
import { MENU_SIDEBAR_STATE } from '@app/store';
import { MENU_SIDEBAR_INITIAL_STATE } from '@app/store/reducers/menuCollapsedReducer/menuCollapsed.state';

import type { PayloadAction } from '@reduxjs/toolkit';

const menuCollapsedSlice = createSlice({
  name: MENU_SIDEBAR_STATE,
  initialState: MENU_SIDEBAR_INITIAL_STATE,
  reducers: {
    setMenuSidebarState: (
      state,
      { payload }: PayloadAction<NPage.MenuSidebarState>
    ) => {
      state.menuSidebarState = payload;
    },
  },
});

export const { setMenuSidebarState } = menuCollapsedSlice.actions;
export const menuCollapsedReducer = menuCollapsedSlice.reducer;
